// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2i1u0","infoBtn":"quickbooks_infoBtn__1OrVC","formBox":"quickbooks_formBox__3lO9i","formFooter":"quickbooks_formFooter__2A-dV"};